'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bolt';
var width = 512;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = ['M116.5 272L310.7 88c-29.2 95.7-44.7 146.3-46.4 152L396 240 201.8 424c29.2-95.6 44.7-146.3 46.4-152l-131.8 0z', 'M350.7-16l-6.9 6.6-304 288-43.7 41.4 187.4 0-54.1 177-9.5 31 42 0 6.9-6.6 304-288 43.7-41.4-187.4 0 54.1-177 9.5-31-42 0zM116.5 272L310.7 88c-29.2 95.7-44.7 146.3-46.4 152L396 240 201.8 424c29.2-95.6 44.7-146.3 46.4-152l-131.8 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;